import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Customers } from '@/pages/Customers'
import { useAppStore } from '@/store'
import { clearCurrentUser } from '@/db/indexedDB'

export const Dashboard: React.FC = () => {
  const { isLoading, user } = useAuth0()
  const { setUser } = useAppStore()

  // Clear any previously selected customer so the header breadcrumb and
  // SubHeader tabs don't carry over when returning to the Customers list.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setUser(null)
    clearCurrentUser()
  }, []) // intentionally empty — run once on mount

  if (isLoading || !user) return null

  return <Customers />
}
